import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Portfolio } from './components/Portfolio';
import { Services } from './components/Services';
import { ShopifySpotlight } from './components/ShopifySpotlight';
import { About } from './components/About';
import { Process } from './components/Process';
import { FinalCTA } from './components/FinalCTA';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-ink-950 font-sans text-mist" data-id="element-0" data-mp="31aqfgfhzusqq">
      <Header data-id="element-1" data-mp="31ctefp14jw7l" />
      <main data-id="element-2" data-mp="31cjpm4rtfv3h">
        <Hero data-id="element-3" data-mp="2wka20ve6b74d" />
        <TrustBar data-id="element-4" data-mp="2wjgu3r3habkn" />
        <Portfolio data-id="element-5" data-mp="2wj8cxn0bok3n" />
        <Services data-id="element-6" data-mp="2wip5j08ate3v" />
        <ShopifySpotlight data-id="element-7" data-mp="2wi5nljineppu" />
        <About data-id="element-8" data-mp="28tw5osok2m3z" />
        <Process data-id="element-9" data-mp="28te198rqp1kz" />
        <FinalCTA data-id="element-10" data-mp="28suumo7jhzm9" />
        <ContactForm data-id="element-11" data-mp="28sbb5328r364" />
      </main>
      <Footer data-id="element-12" data-mp="23vktwcepa1j4" />
    </div>;
}